var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEstruturaFeed = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 178,
  height: 163,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: 8,
  y: 6,
  width: 172,
  height: 156
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 6h172v156H8V6z",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M119.996 161.321l6.445-24.983 37.373-.438 2.582 26.297",
  fill: "url(#paint0_linear)"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M98.797 46.487a28.07 28.07 0 01-2.74-3.226c-.52-.663-.967-1.38-1.334-2.139a15.51 15.51 0 01-.826-2.454l-1.422-5.172a.928.928 0 010-.386.701.701 0 01.65-.596c.33-.019.659.074.93.263a4.823 4.823 0 011.757 2.35c.368.894.843 4.014 2.423 2.98a1.753 1.753 0 00.703-1.543 2.75 2.75 0 00-.79-1.858c-.703-.702-1.757-.982-2.407-1.753a2.364 2.364 0 010-2.91 2.959 2.959 0 01.246-3.402 1.753 1.753 0 01-.562-2.226 2.492 2.492 0 012.002-1.315c3.759-.386 6.077 4.453 7.201 7.293a23.427 23.427 0 004.11 7.977",
  fill: "#C1813E"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M150.097 82.848l-29.751-25.737-11.731-21.459-13.488 12.273 17.562 26.473a21.748 21.748 0 004.18 4.698l16.737 14.131",
  fill: "#079D56"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M127.248 88.441l.141 1.911-7.043-33.24 26.221 22.282",
  fill: "#079D56"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  }
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M95.847-2.076l-.158 51-.228 81.383v18.812a1.368 1.368 0 001.36 1.212 1.37 1.37 0 001.362-1.212l.087-50.913.246-81.383.053-18.9a1.367 1.367 0 00-1.361-1.212 1.371 1.371 0 00-1.361 1.213zM64.2-2.164l-.141 51-.246 81.383v18.812a1.373 1.373 0 002.339.967c.256-.256.4-.604.4-.967l.141-51 .246-81.383V-2.164a1.366 1.366 0 00-1.37-1.367 1.371 1.371 0 00-1.37 1.367zM32.534 10.231l-.123 42.76-.193 67.779v15.691a1.368 1.368 0 002.338.967c.257-.257.401-.605.401-.967l.123-42.778.194-67.779V10.231a1.366 1.366 0 00-1.37-1.367 1.371 1.371 0 00-1.37 1.367zM127.424 15.596l-.299 101.562v14.482a1.368 1.368 0 001.362 1.212 1.37 1.37 0 001.361-1.212l.298-101.58V15.596a1.367 1.367 0 00-1.361-1.213 1.372 1.372 0 00-1.361 1.213z",
  fill: "#AC41D8"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.736 39.124l51.212.158 81.718.228h18.88a1.373 1.373 0 001.37-1.368 1.366 1.366 0 00-1.37-1.367l-51.212-.14-81.719-.176H7.735a1.37 1.37 0 00-1.214 1.359 1.366 1.366 0 001.215 1.358v-.052zM-1.748 96.172l43.028.123 68.652.158h15.806a1.371 1.371 0 001.215-1.359 1.367 1.367 0 00-1.215-1.358l-43.01-.123-68.6-.123H-1.678a1.37 1.37 0 00-1.215 1.359 1.366 1.366 0 001.215 1.358l-.07-.035zM11.845 124.679l43.028.123 68.652.193h15.806a1.369 1.369 0 00.969-2.335 1.372 1.372 0 00-.969-.4l-43.028-.123-68.652-.193H11.845a1.37 1.37 0 00-.969 2.335c.257.256.606.4.969.4zM3.96 67.63l45.662.14 73.306.211H139.7a1.369 1.369 0 00.867-2.27 1.368 1.368 0 00-.867-.447l-45.662-.14-73.253-.228H3.96a1.371 1.371 0 00-1.215 1.358 1.366 1.366 0 001.215 1.36v.017z",
  fill: "#AC41D8"
}))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M84.132 133.813l-5.268.298c-2.88.158-5.708.439-8.588.596-.65 0-1.51.281-1.51.93a1.067 1.067 0 00.596.824c.803.39 1.662.651 2.547.771a2.751 2.751 0 012.055 1.525 2.66 2.66 0 01-1.265 2.77 7.27 7.27 0 01-6.287.877 9.817 9.817 0 00-1.756-.351 1.99 1.99 0 00-1.581.579 2.294 2.294 0 00-.123 2.332 9.06 9.06 0 006.27 5.084c5.708 1.525 12.294-.982 17.738-2.823M135.855 90.737l-3.829-10.852c-2.055-1.087-3.811-1.753-5.778-2.928a5.972 5.972 0 01-2.863-2.822 5.798 5.798 0 01.931-4.453 70.674 70.674 0 013.267-5.558c-.878-.578-1.862-1.402-1.756-2.454.105-1.052.878-1.35 1.58-1.754l5.146-3.208a18.628 18.628 0 014.496-2.332c.896-.26 1.813-.442 2.74-.543a14.672 14.672 0 017.341.333 9.43 9.43 0 014.443 3.015 12.483 12.483 0 011.511 10.642 22.56 22.56 0 01-5.849 9.345l3.864 8.468",
  fill: "#C1813E"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M132.57 63.143a.543.543 0 10.001-1.087.543.543 0 00-.001 1.087z",
  fill: "#2B2B2B"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  }
}, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M127.459 67.385a3.524 3.524 0 002.863.456.34.34 0 00.202-.163.34.34 0 00-.395-.486 2.816 2.816 0 01-2.353-.403c-.352-.245-.668.35-.317.596z",
  fill: "#C1813E"
}))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M143.512 81.042l-19.319 7.54a13.155 13.155 0 00-5.112 3.609 13.119 13.119 0 00-2.861 5.56l-3.513 14.674a10.988 10.988 0 01-5.269 7.012l-26.203 14.394 7.025 16.34 36.53-17.164-.667 11.624 40.885-.351v-22.792a74.622 74.622 0 00-9.132-35.975 9.953 9.953 0 00-5.338-4.562 9.973 9.973 0 00-7.026.091z",
  fill: "#00D38D"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M143.512 81.042l-19.319 7.54a13.155 13.155 0 00-5.112 3.609 13.119 13.119 0 00-2.861 5.56l-3.513 14.674a10.988 10.988 0 01-5.269 7.012l-26.203 14.394 7.025 16.34 36.53-17.164-.667 11.624 40.885-.351v-22.792a74.622 74.622 0 00-9.132-35.975 9.953 9.953 0 00-5.338-4.562 9.973 9.973 0 00-7.026.091z",
  fill: "url(#paint1_linear)"
}), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M151.274 75.415c1.141-1.543 2.265-3.05 3.512-4.47a10.639 10.639 0 002.459-4.594 8.038 8.038 0 000-1.455 8.755 8.755 0 00-2.248-5.856 13.918 13.918 0 00-5.585-4.102c-1.633-.632-3.389-.895-4.952-1.754-2.582-1.297-4.69-3.348-7.447-4.33a3.852 3.852 0 00-3.934.508 3.086 3.086 0 00-.615 3.279c1.212 3.156 8.027 3.506 7.57 7.696a7.467 7.467 0 01-.861 2.104 2.067 2.067 0 000 2.139 1.859 1.859 0 001.581.508c.825 0 1.756-.578 2.582-.262a2.631 2.631 0 011.528 2.682 3.867 3.867 0 01-1.757 2.717 7.118 7.118 0 01-3.091 1.105 6.102 6.102 0 00-.983.193 7.677 7.677 0 00.421 6.03 5.425 5.425 0 004.286 2.07 8.317 8.317 0 004.232-.895 9.69 9.69 0 003.302-3.313z",
  fill: "#2B2B2B"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M154.541 70.856l-23.727-22.16a2.084 2.084 0 01-.123-2.91 2.072 2.072 0 012.863-.175l1.756 1.507a8.648 8.648 0 009.484 1l1.756-.86a11.73 11.73 0 0113.944 2.367 11.661 11.661 0 01.808 15.042l-4.548 6.014a1.454 1.454 0 01-1.066.598 1.46 1.46 0 01-1.147-.423z",
  fill: "#EE8322"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M154.541 70.856l-23.727-22.16a2.084 2.084 0 01-.123-2.91 2.072 2.072 0 012.863-.175l1.756 1.507a8.648 8.648 0 009.484 1l1.756-.86a11.73 11.73 0 0113.944 2.367 11.661 11.661 0 01.808 15.042l-4.548 6.014a1.454 1.454 0 01-1.066.598 1.46 1.46 0 01-1.147-.423z",
  fill: "url(#paint2_linear)"
}), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M132.025 79.885l3.847 1.034-2.986 1.385",
  fill: "#C1813E"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M32.446 39.194h2.74l-2.74 4.418M64.094 39.264h2.722l-2.74 4.418M127.336 39.474h2.74l-2.757 4.419M32.358 67.7h2.74L32.34 72.12M63.989 67.84h2.74L63.97 72.26M95.618 67.858h2.74l-2.74 4.418M32.27 96.243h2.722l-2.74 4.418M63.883 96.348h2.722l-2.74 4.418M95.53 96.4h2.74l-2.757 4.418M32.183 124.679h2.722l-2.74 4.418M63.777 124.802h2.74l-2.757 4.418",
  fill: "#AC41D8"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 143.196,
  y1: 135.9,
  x2: 143.196,
  y2: 162.197,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#006B3F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 144.267,
  y1: 156.219,
  x2: 109.934,
  y2: 96.647,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00D38D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 130.146,
  y1: 58.181,
  x2: 163.638,
  y2: 58.181,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EE8322"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEstruturaFeed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/estruturaFeed.f154af7a70f11887d28e3cc2aa53b883.svg";